export const VerticalDotsIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.33268 4.0013C9.33268 4.73702 8.73491 5.33464 7.99935 5.33464C7.26364 5.33464 6.66602 4.73686 6.66602 4.0013C6.66602 3.26559 7.26379 2.66797 7.99935 2.66797C8.73506 2.66797 9.33268 3.26559 9.33268 4.0013Z"
        fill="#222530"
      />
      <path
        d="M9.33268 8.0013C9.33268 8.7378 8.73581 9.33464 7.99935 9.33464C7.26289 9.33464 6.66602 8.73776 6.66602 8.0013C6.66602 7.26484 7.26289 6.66797 7.99935 6.66797C8.73581 6.66797 9.33268 7.26484 9.33268 8.0013Z"
        fill="#222530"
      />
      <path
        d="M9.33268 12.0013C9.33268 12.737 8.7349 13.3346 7.99935 13.3346C7.26363 13.3346 6.66602 12.7369 6.66602 12.0013C6.66602 11.2656 7.26379 10.668 7.99935 10.668C8.73506 10.668 9.33268 11.2656 9.33268 12.0013Z"
        fill="#222530"
      />
    </svg>
  );
};
